export default {"src":"/pro/_next/static/media/ena.7c693c48.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};